'use strict'

module.exports = require('../../../shared/page-record-link.js')
